/* /dev/kit: every kit component in both directions. Only in dev builds or mock mode. */
import { page, type AreaRoutes } from '@/app/routes'
import { devToolsEnabled } from '@/lib/env'

export const routes: AreaRoutes = devToolsEnabled
  ? { public: [{ path: 'dev/kit', lazy: page(() => import('./pages/KitPage')) }] }
  : {}
